package org.hs_soft.runmynesto.domain.model.home.options.operation.option_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getAppConfig")
    val getAppConfig: OptionModel ?=null,
    @SerialName("updateAppConfig")
    val updateAppConfig:OptionModel?=null,
    @SerialName("__typename")
    val typename: String?
)